var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1205 3994 c-730 -136 -1237 -768 -1202 -1499 31 -668 498 -1217 1157 -1361 121 -27 449 -27 570 0 548 120 975 528 1111 1062 61 241 61 487 0 728 -136 532 -557 937 -1106 1061 -102 24 -425 29 -530 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3651 3914 c-195 -52 -370 -252 -487 -555 -137 -355 -173 -873 -89 -1286 64 -312 177 -554 335 -714 95 -97 173 -141 278 -161 256 -48 525 200 666 613 73 215 106 413 113 684 12 431 -73 810 -244 1099 -57 97 -196 240 -269 279 -103 54 -203 68 -303 41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4845 3781 c-94 -39 -174 -326 -216 -776 -16 -168 -16 -711 -1 -885 43 -468 126 -753 228 -784 27 -8 78 32 103 83 191 376 217 1635 45 2166 -35 105 -56 147 -94 179 -34 28 -36 29 -65 17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.4b6115f979969665eb3492d2699c2ef6.svg";
export { ForwardRef as ReactComponent };